import { supabase } from './supabaseClient';

class DimensionPresetStorage {
  _toApp(row) {
    return {
      id: row.id,
      name: row.name,
      description: row.description,
      mode: row.mode,
      width: row.width,
      height: row.height,
      maxWidth: row.max_width,
      aspectRatio: row.aspect_ratio,
      isBuiltIn: false,
      createdAt: row.created_at,
      updatedAt: row.updated_at
    };
  }

  async getAllPresets() {
    const { data, error } = await supabase
      .from('dimension_presets')
      .select('*')
      .order('created_at', { ascending: true });

    if (error) throw error;
    return (data || []).map(row => this._toApp(row));
  }

  async createPreset(presetData) {
    const row = {
      name: presetData.name,
      description: presetData.description || '',
      mode: presetData.mode || 'fixed',
      width: presetData.width,
      height: presetData.height,
      max_width: presetData.maxWidth || 980,
      aspect_ratio: presetData.aspectRatio || null
    };

    const { data, error } = await supabase
      .from('dimension_presets')
      .insert(row)
      .select()
      .single();

    if (error) throw error;
    return this._toApp(data);
  }

  async updatePreset(id, presetData) {
    const row = {
      name: presetData.name,
      description: presetData.description,
      mode: presetData.mode,
      width: presetData.width,
      height: presetData.height,
      max_width: presetData.maxWidth,
      aspect_ratio: presetData.aspectRatio,
      updated_at: new Date().toISOString()
    };

    const { data, error } = await supabase
      .from('dimension_presets')
      .update(row)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return this._toApp(data);
  }

  async deletePreset(id) {
    const { error } = await supabase
      .from('dimension_presets')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
}

export const dimensionPresetStorage = new DimensionPresetStorage();
